import RecipeIngredientRegister from "../screens/recipe_simulator/recipeIngredientRegister/RecipeIngredientRegister";
import RecipeSimulatorList from "../screens/recipe_simulator/RecipeSimulatorList";
import ManageRecipeVariant from "../screens/recipe_simulator/recipeVariant/ManageRecipeVariant";
import { adminAccess, salesAccess, supplierAccess, userAccess } from "./useRoleAccess";

export const RecipeSimulatorRoutes = [
  {
    path: "/recipe-simulator",
    route: <RecipeSimulatorList />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess, ...supplierAccess, ...salesAccess]
  },
  {
    path: "/recipe-simulator/:recipeId",
    route: <RecipeIngredientRegister />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess, ...supplierAccess, ...salesAccess]
  },
  {
    path: "/recipe-simulator/:recipeId/manage",
    route: <ManageRecipeVariant />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess, ...supplierAccess, ...salesAccess]
  }
];
